import { ItemModel } from "./structure";
import { localize } from "client_legacy/ndaw/culture";
import { billingRouting } from "../Licensing/Billing/Page";
import { auditLogsRouting } from "../AuditLogging/Page";
import { manageUserRequestsRouting } from "../UserRequests/ManageUserRequestsPage";
import { userManagementRouting } from "../UserManagement/UserManagementPage";
import { userGroupManagementRouting } from "../UserGroupManagement/UserGroupManagementPage";
import { userGroupPermissionRouting } from "../UserGroupPermissions/PermissionManagementPage";
import { userLicensingManagementRouting } from "../Licensing/Licensing/Page";
import { singleSignOnSettingsRouting } from "../SsoSettings/Page";
import { apiKeysRouting } from "../ApiKeys/Overview";
import { afasConfigurationRouting } from "../Connections/Afas/Page";
import { autotaskConfigurationRouting } from "../Connections/Autotask/Page";
import { clientlessRdpRouting } from "../ClientlessRdp/GatewayOverview";
import { egnyteConfigurationRouting } from "../Connections/Egnyte/Page";
import { environmentExchangeSettingsRouting } from "../ExchangeSettings/ExchangeSettings";
import { webDavSettingsRouting } from "../WebDavSettings/WebDavSettings";
import { liquitConfigurationRouting } from "../Connections/Liquit/Page";
import { magisterConfigurationRouting } from "../Connections/Magister/Page";
import { nedapOnsConfigurationRouting } from "../Connections/NedapOns/Page";
import { sharePointSettingsRouting } from "../SharePoint/SharePointSettingsPage";
import { topDeskConfigurationRouting } from "../Connections/TopDesk/Page";
import { vilansKickConfigurationRouting } from "../Connections/VilansKick/Page";
import { zaaksysteemConfigurationRouting } from "../Connections/Zaaksysteem/Page";
import { zenyaConfigurationRouting } from "../Connections/Zenya/Page";
import { zermeloConfigurationRouting } from "../Connections/Zermelo/Page";
import { userProvisioningRouting } from "../UserProvisioning/UserProvisioningPage";
import { workspaceManagementRouting } from "client/Features/Settings/WorkspaceManagement/WorkspaceManagement";
import { securityConfigurationRouting } from "../SecurityConfiguration/SecurityConfigurationPage";
import { brandingRouting } from "../Branding/Overview/BrandingOverview";
import { environmentEmailSettingsRouting } from "../Email/EnvironmentSettings/EnvironmentEmailPage";
import { SettingsPageKind } from "client/Api/SettingsLayout/settingsLayout";
import { userLicenseManagementRouting } from "../Licensing/UserLicenseManagement/UserLicenseManagementPage";
import { AnalyticsRouting } from "../Analytics/Page";
import { sibiConfigurationRouting } from "../Connections/Sibi/Page";
import { intercomConfigurationRouting } from "../Connections/Intercom/Page";
import { integrationBuilderRouting } from "../IntegrationBuilder/OverViewPage";
import { SearchSettingsRouting } from "../Search/SearchSettingsPage";
import { AiAssistantSettingsRouting } from "../AiAssistant/Page";
import { termsRouting } from "../Terms/TermsPage";

export const environmentSettings: readonly ItemModel[] = [
	{
		id: "billing-menu-item",
		kind: "group",
		name: localize("_Billing"),
		children: [
			{
				id: SettingsPageKind.BillingInfo,
				kind: "link",
				name: localize("_CompanyInformation"),
				navigation: billingRouting.page
			},
			{
				id: SettingsPageKind.FeaturePackages,
				kind: "link",
				name: localize("_Packages"),
				navigation: userLicenseManagementRouting.overview
			},
			{
				id: SettingsPageKind.Licensing,
				kind: "link",
				name: localize("_Licensing"),
				navigation: userLicensingManagementRouting.page
			}
		]
	},
	{
		id: "insights-menu-item",
		kind: "group",
		name: localize("_Insights"),
		children: [
			{
				id: SettingsPageKind.AuditLogging,
				kind: "link",
				name: localize("_AuditLogging"),
				navigation: auditLogsRouting.page
			},
			{
				id: SettingsPageKind.Analytics,
				kind: "link",
				name: localize("_Analytics"),
				navigation: AnalyticsRouting.page
			}
		]
	},
	{
		id: SettingsPageKind.UserRequests,
		kind: "link",
		name: localize("_UserRequests"),
		navigation: manageUserRequestsRouting.page
	},
	{
		id: "users-and-user-groups-group",
		kind: "group",
		name: localize("_UsersAndGroups"),
		children: [
			{
				id: SettingsPageKind.UserManagement,
				kind: "link",
				name: localize("_UserManagement"),
				navigation: userManagementRouting.overview
			},
			{
				id: SettingsPageKind.UserGroupManagement,
				kind: "link",
				name: localize("_UserGroupsManagement"),
				navigation: userGroupManagementRouting.overview
			},
			{
				id: SettingsPageKind.GroupPermissions,
				kind: "link",
				name: localize("_DefaultPermissions"),
				navigation: userGroupPermissionRouting.overview
			},
			{
				id: SettingsPageKind.UserProvisioning,
				kind: "link",
				name: localize("_UserProvisioning"),
				navigation: userProvisioningRouting.page
			}
		]
	},
	{
		id: SettingsPageKind.AiAssistant,
		kind: "link",
		name: localize("_AiAssistant"),
		navigation: AiAssistantSettingsRouting.page
	},
	{
		id: SettingsPageKind.SingleSignOn,
		kind: "link",
		name: localize("_SingleSignOn"),
		navigation: singleSignOnSettingsRouting.page
	},
	{
		id: SettingsPageKind.GlobalSearch,
		kind: "link",
		name: localize("_GlobalSearch"),
		navigation: SearchSettingsRouting.page
	},
	{
		id: "integrations-group",
		kind: "group",
		name: localize("_Integrations"),
		children: [
			{
				id: SettingsPageKind.IntegrationBuilder,
				kind: "link",
				name: localize("_IntegrationBuilder"),
				navigation: integrationBuilderRouting.overview
			},
			{
				id: SettingsPageKind.ApiKeys,
				kind: "link",
				name: localize("_ApiSettings"),
				navigation: apiKeysRouting.overview
			},
			{
				id: SettingsPageKind.Afas,
				kind: "link",
				name: localize("_AfasConnections"),
				navigation: afasConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Autotask,
				kind: "link",
				name: localize("_AutotaskConnections"),
				navigation: autotaskConfigurationRouting.page
			},
			{
				id: SettingsPageKind.ClientlessRDP,
				kind: "link",
				name: localize("_ClientlessRDP"),
				navigation: clientlessRdpRouting.gatewayOverview
			},
			{
				id: SettingsPageKind.Egnyte,
				kind: "link",
				name: localize("_EgnyteConnection"),
				navigation: egnyteConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Exchange,
				kind: "link",
				name: localize("_ExchangeSettings"),
				navigation: environmentExchangeSettingsRouting.page
			},
			{
				id: SettingsPageKind.FileServers,
				kind: "link",
				name: localize("_FileServers"),
				navigation: webDavSettingsRouting.page
			},
			{
				id: SettingsPageKind.Intercom,
				kind: "link",
				name: localize("_IntercomConnection"),
				navigation: intercomConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Magister,
				kind: "link",
				name: localize("_MagisterConnections"),
				navigation: magisterConfigurationRouting.page
			},
			{
				id: SettingsPageKind.NedapOns,
				kind: "link",
				name: localize("_NedapOnsConnections"),
				navigation: nedapOnsConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Liquit,
				kind: "link",
				name: localize("_RecastConnections"),
				navigation: liquitConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Sharepoint,
				kind: "link",
				name: localize("_SharePointSettings"),
				navigation: sharePointSettingsRouting.page
			},
			{
				id: SettingsPageKind.Sibi,
				kind: "link",
				name: localize("_SibiConnection"),
				navigation: sibiConfigurationRouting.page
			},
			{
				id: SettingsPageKind.TopDesk,
				kind: "link",
				name: localize("_TopDeskConnections"),
				navigation: topDeskConfigurationRouting.page
			},
			{
				id: SettingsPageKind.VilansKick,
				kind: "link",
				name: localize("_VilansKickConnections"),
				navigation: vilansKickConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Zaaksysteem,
				kind: "link",
				name: localize("_ZaaksysteemConnections"),
				navigation: zaaksysteemConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Zenya,
				kind: "link",
				name: localize("_ZenyaConnections"),
				navigation: zenyaConfigurationRouting.page
			},
			{
				id: SettingsPageKind.Zermelo,
				kind: "link",
				name: localize("_ZermeloConnections"),
				navigation: zermeloConfigurationRouting.page
			},
		]
	},
	{
		id: SettingsPageKind.WorkspaceManagement,
		kind: "link",
		name: localize("_WorkspaceManagement"),
		navigation: workspaceManagementRouting.page
	},
	{
		id: SettingsPageKind.Security,
		kind: "link",
		name: localize("_Security"),
		navigation: securityConfigurationRouting.path
	},
	{
		id: SettingsPageKind.Branding,
		kind: "link",
		name: localize("_Branding"),
		navigation: brandingRouting.overview
	},
	{
		id: SettingsPageKind.EnvironmentEmail,
		kind: "link",
		name: localize("_Email"),
		navigation: environmentEmailSettingsRouting.page
	},
	{
		id: SettingsPageKind.Terms,
		kind: "link",
		name: localize("_Terms"),
		navigation: termsRouting.page
	}
];